import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Radio } from 'antd';
import { Button } from '@cropler/ui-kit';
import { Languages } from '../../i18n/constants';
import { catalogApi } from '../../store/api/catalog';

import styles from './styles.module.scss';

const LocalizationForm = ({ onDone }) => {
  const { i18n } = useTranslation();
  const currentLang = Languages.find((item) => item.key === i18n.language) ? i18n.language : 'en';
  const dispatch = useDispatch();

  const [value, setValue] = useState(currentLang);

  const options = Languages.map((lang) => ({
    label: lang.label,
    value: lang.key,
  }));

  const onChangeLang = ({ key }) => {
    setValue(key);
  };

  const onSaveLang = () => {
    i18n.changeLanguage(value).catch((error) => {
      console.error('Failed to change language:', error);
    });
    // Translate crops list
    dispatch(catalogApi.util.resetApiState());
    onDone?.();
  };

  return (
    <div className={styles.langForm}>
      <h2 className={styles.langFormTitle}>Select app language</h2>
      <Radio.Group
        className={styles.langFormList}
        vertical
        value={value}
        options={options}
        onChange={({ target: { value } }) => onChangeLang({ key: value })}
      />
      <Button className={styles.langFormButton} type={'primary'} size={'large'} onClick={onSaveLang}>
        Select language
      </Button>
    </div>
  );
};

export default LocalizationForm;
